import { render, staticRenderFns } from "./subprogram-view-toolbar.vue?vue&type=template&id=72f65739&"
import script from "./subprogram-view-toolbar.vue?vue&type=script&lang=js&"
export * from "./subprogram-view-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports